import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBoolean } from '@/utils';
import classnames from 'classnames';
import { Icon } from '../Icon';
import styles from './index.module.less';
export const Hint = ({ className, children, height, width, position = 'left', bubbleProps, ...rest }) => {
    const [visible, show, hide] = useBoolean();
    return (_jsxs("span", { className: classnames(styles.container, className, styles[position]), ...rest, children: [_jsx(Icon, { type: "help", size: 18, onMouseOver: show, onMouseLeave: hide }), visible && (_jsx("div", { className: classnames(styles.bubble, bubbleProps?.className), style: { height, width, ...bubbleProps?.style }, children: children }))] }));
};
